import { GlobalEmailNotificationsSetting } from 'constants/notification-settings';
export const transformNotificationSettingDto = setting => {
  const isGlobalSection = setting.name === GlobalEmailNotificationsSetting.Section;
  return {
    isGlobalSection,
    id: setting.name,
    title: setting.type === 'invisible_header' ? undefined : setting.title,
    settings: setting.value.filter(_ref => {
      let {
        type
      } = _ref;
      return type === 'boolean';
    }).map(booleanSetting => ({
      id: booleanSetting.name,
      title: booleanSetting.title,
      description: booleanSetting.description,
      isGlobalEmailSwitch: isGlobalSection && booleanSetting.name === GlobalEmailNotificationsSetting.Setting,
      enabled: Boolean(booleanSetting.value)
    }))
  };
};
export const transformNotificationSettingsDto = settings => settings.map(transformNotificationSettingDto);